window.addEventListener("DOMContentLoaded", function() { 

    const collectionProductGridSection = document.querySelector('.collectionProductGrid')

    if(Shopify.designMode) {
        document.addEventListener('shopify:section:load', (e) => {
            if (e.target.dataset.shopifyEditorSection.includes('mainCollectionProductGrid')) {
                init(document.querySelector('.collectionProductGrid'))
            }
        })
    }

    let cache = []
    let initUrl = window.location.search
    cache.push({url: initUrl ? `${initUrl}`: '', dom: new XMLSerializer().serializeToString(collectionProductGridSection)})


    let initParams = (new URL(document.location)).searchParams;
    let initSearchParam = initParams.get('q')

    let filtersList = {
        search: initSearchParam ? `q=${initSearchParam}` : "",
        page: "",
        sortBy: "",
        filters: "",
        minPrice: "",
        maxPrice: ""
    } 

    init(collectionProductGridSection)

    function init(root) {
        // Show/hide filter modal
        let filterModal = root.querySelector('#filterModal')
        let filterRelativeWrapper = root.querySelector('#filterRelativeWrapper')
        let filterModalWrapper = root.querySelector('.filterModalWrapper')
        let showModalBtn = root.querySelectorAll('.gridFilterBtnWrap .formBtn')
        let modalFloatyBtn = root.querySelector('.filterModalWrapper .floatyBtn')
        let dataGridGap = root.querySelector('#dataGridGap')

        if(modalFloatyBtn) {
            modalFloatyBtn.addEventListener('click', modalControl)
        }

        if(showModalBtn && filterRelativeWrapper) {
            showModalBtn.forEach(btn => {
                btn.addEventListener('click', modalControl)
            })

            if(window.innerWidth >= 800) {
                if(filterRelativeWrapper.dataset.visible == "true") {       
                    filterModalWrapper.classList.remove('displayNone')            
                } 
            } else {
                filterRelativeWrapper.dataset.visible = "false"             
            }
        }



        function modalControl() {
            const show = [
                { transform: 'translateX(-600px)' },
                { transform: 'translateX(0)' }
            ]
        
            const hide = [
                { transform: 'translateX(-600px)' }
            ]
        
            const options = {
                duration: 250,
                iterations: 1,
                fill: 'forwards'
            }
            
            let isVisible = filterRelativeWrapper.dataset.visible
            if(isVisible == "true") {
                filterRelativeWrapper.dataset.visible = "false"
                filterRelativeWrapper.animate(hide, options)      
                showModalBtn[0].querySelector('span').innerText = window.accessibilityStrings.show_filters_desktop     
                showModalBtn[1].querySelector('span').innerText = window.accessibilityStrings.show_filters_mobile     
                setTimeout(() => {
                    filterModalWrapper.classList.add('displayNone')            
                }, options.duration);
            } else {
                showModalBtn[0].querySelector('span').innerText = window.accessibilityStrings.hide_filters_desktop     
                showModalBtn[1].querySelector('span').innerText = window.accessibilityStrings.hide_filters_mobile  
                filterModalWrapper.classList.remove('displayNone')            
                filterRelativeWrapper.animate(show, options)
                filterRelativeWrapper.dataset.visible = "true"
            }

        }


        // Show/hide filter options lists

        let filterDisplayBtns = root.querySelectorAll('.filterDisplayBtns')

        filterDisplayBtns.forEach(btn => {
            btn.addEventListener('click', displayFilterList)
        })

        function displayFilterList(e) {
            let listId = e.currentTarget.dataset.controlElement
            root.querySelector('#' + listId).classList.toggle('displayNone')
        }

        // Set correct height for the filter modal
        setFilterWrapHeight()

        window.addEventListener('resize', setFilterWrapHeight)

        function setFilterWrapHeight() {
            if (!filterModal) { return }
            filterModal.style.height = 0
            let productWrap = root.querySelectorAll('.productWrap')
            let windowWidth = window.innerWidth
            let height = 800; 
            if(windowWidth < 1200) {
                if (productWrap[0] && productWrap[1]) {
                    height = productWrap[0].clientHeight + productWrap[1].clientHeight
                }
            } else if(windowWidth < 1440) {
                if (productWrap[0] && productWrap[2]) {
                    height = productWrap[0].clientHeight + productWrap[2].clientHeight
                }
            } else {
                if (productWrap[0] && productWrap[3]) {
                    height = productWrap[0].clientHeight + productWrap[3].clientHeight
                }
            }

            if(window.innerWidth > 800) {
                filterModal.style.height = `${height + parseInt(dataGridGap.dataset.gridGap)}px`
            } else {
                filterModal.style.height = ''
            }

        }


        // FILTER CONTROL
        const clearFiltersBtn = root.querySelector('.clearFiltersBtn')
        const sortBtns = root.querySelectorAll('.sortBtn')
        const constFilterWtapper = root.querySelector('#filterModalWrapper')
        const priceFilter = root.querySelectorAll('.priceFilter')
        const priceFilterMin = root.querySelectorAll('.priceFilter')[0]
        const priceFilterMax = root.querySelectorAll('.priceFilter')[1]


        const iconStaticWrap = root.querySelectorAll('.iconStaticWrap')
        const iconLoadingWrap = root.querySelectorAll('.iconLoadingWrap')

        const sectionId = root.querySelector('#mainCollectionSectionId').dataset.sectionId 

        const customCheckboxWrap = root.querySelectorAll('.customCheckboxWrap')

        const filterCounterSpan = root.querySelector('#filterCounter')

        const collectionpagination = root.querySelector('.collectionpagination')
        const collectionProductGrid =  root

        let navigationOccured = false
        
        
        window.addEventListener('popstate', (e) => {
            if (history.scrollRestoration) {
                history.scrollRestoration = 'manual';
            }

            if(e.state) {
                filtersList = {...e.state}                
            } else {
                filtersList = {
                    search: "",
                    page: "",
                    sortBy: "",
                    filters: "",
                    minPrice: "",
                    maxPrice: ""
                } 
            }

            let findCache = cache.find(obj => obj.url == window.location.search)
            if (findCache) {
                let cachedDom = new DOMParser().parseFromString(findCache.dom ,'text/html')
                root.querySelectorAll('.productWrap').forEach(el => {
                    el.remove()
                })

                if(root.querySelector('.priceFilterMin')) {
                    let minCacheVal = cachedDom.querySelector('.priceFilterMin').value 
                    root.querySelector('.priceFilterMin').value = parseInt(filtersList.minPrice.split('=')[1], 10)

                    let maxCacheVal = cachedDom.querySelector('.priceFilterMax').value
                    root.querySelector('.priceFilterMax').value = parseInt(filtersList.maxPrice.split('=')[1], 10)
                }

                if (sortBtns) {
                    for (let i = 0; i < sortBtns.length; i++) {
                        if(sortBtns[i].textContent.trim() == cachedDom.querySelector('.sortBarBtns.btnActive').textContent.trim()) {
                            sortBtns[i].classList.add('btnActive')
                        } else {
                            sortBtns[i].classList.remove('btnActive')
                        }
                    }
                }


                collectionpagination.children[0].remove()
                collectionpagination.append(cachedDom.querySelector('.collectionpagination').children[0])

                root.querySelector('.collectionGrid').append(...cachedDom.querySelectorAll('.productWrap'))
                
                cachedDom.querySelectorAll('.customCheckboxWrap').forEach((list, i) => {
                    let isChecked = list.dataset.isChecked 
                    customCheckboxWrap[i].dataset.isChecked = isChecked 
                    if (isChecked == "true") {
                        customCheckboxWrap[i].querySelector('.customCheckboxSvg').classList.remove('displayNone')
                    } else {
                        customCheckboxWrap[i].querySelector('.customCheckboxSvg').classList.add('displayNone')
                    }
    
                    customCheckboxWrap[i].querySelector('.availabilityCount').innerText = list.querySelector('.availabilityCount').innerText
                    let isDisabled = list.dataset.isDisabled
                    customCheckboxWrap[i].dataset.isDisabled = isDisabled
                    if (isDisabled) {
                        customCheckboxWrap[i].classList.add('customCheckboxDisabled')
                    } else {
                        customCheckboxWrap[i].classList.remove('customCheckboxDisabled')
                    }
                })
                setFilterWrapHeight()
                countFiltersFromParams()
            } else {
                navigationOccured = true
                fetchSection()
            }

        })

        let pageChange = false


        if(clearFiltersBtn) {
            clearFiltersBtn.addEventListener('click', () => {
                for (filter in filtersList) {
                    if(filter != 'search') {
                        filtersList[filter] = ""
                    }
                }
    
                if(priceFilterMin) {
                    priceFilterMin.value = "" 
                    priceFilterMax.value = ""
                }
    
                navigationOccured = true
                window.location.search = filtersList.search ? filtersList.search : ''
                fetchSection()
            })
        }


        if(collectionpagination) {
            collectionpagination.addEventListener('click', handlePagination)
        }

        sortBtns.forEach(btn => {
            btn.addEventListener('click', handleSort)
        })

        customCheckboxWrap.forEach(checkbox => {
            checkbox.addEventListener('click', handleFilter)
        })

        priceFilter.forEach(inp => {
            inp.addEventListener('keyup', handlePrice)
        })


        countFiltersFromParams()


        function handlePagination(e) {
            e.preventDefault()
            if (e.target.classList.contains('navElement')) {
                let pageNumber

                e.target.href.split('&').forEach(str => {
                    if(str.includes('page')) {
                        pageNumber = str.split('=')[1]
                    }
                })
                filtersList.page = `page=${pageNumber}`
                pageChange = true 
                fetchSection()
            }

        }

        function handlePrice(e) {
            if(e.key == 'Tab' || e.key == 'Shift') { return }
            filtersList.page = ""
            const filterLabel = e.currentTarget.dataset.filterLabel
            const filterType = e.currentTarget.dataset.filterType
            const value = e.currentTarget.value.trim()

            if (filterType == "gte") {
                if (value) {
                    filtersList.minPrice = `${filterLabel}.gte=${value}`
                } else {
                    filtersList.minPrice = ""
                }
            } else if (filterType == "lte") {
                if (value) {
                    filtersList.maxPrice = `${filterLabel}.lte=${value}`
                } else {
                    filtersList.maxPrice = ""
                }
            }
            const deb = debounce(() => fetchSection())
            deb()
        }

        function handleSort (e) {
            filtersList.page = ""
            for (let i = 0; i < sortBtns.length; i++) {
                if(sortBtns[i].textContent.trim() == e.currentTarget.textContent.trim()) {
                    sortBtns[i].classList.add('btnActive')
                } else {
                    sortBtns[i].classList.remove('btnActive')
                }
            }

            filtersList.sortBy = `sort_by=${e.currentTarget.dataset.sortValue}`
            fetchSection()
        }

        function handleFilter() {
            filtersList.page = ""
            filtersList.filters = ""
            customCheckboxWrap.forEach(checkbox => {
                if(checkbox.dataset.isChecked == 'true'){
                    const filterValue = new URLSearchParams(checkbox.dataset.filterWithValue).toString()
                    if (filtersList.filters.length == 0) {
                        filtersList.filters += filterValue
                    } else {
                        filtersList.filters += `&${filterValue}`
                    }
                }
            })
            fetchSection()
        }

        function updateGridItems(dom, params, domAsText){
            // Clear items currently on page
            root.querySelectorAll('.productWrap').forEach(el => {
                el.remove()
            })

            const newGridElements = dom.querySelectorAll('.productWrap')
            const newFilterLists = dom.querySelectorAll('.customCheckboxWrap')


            newFilterLists.forEach((list, i) => {
                if (navigationOccured) {
                    let isChecked = list.dataset.isChecked

                    customCheckboxWrap[i].dataset.isChecked = isChecked 
                    if (isChecked == "true") {
                        customCheckboxWrap[i].querySelector('.customCheckboxSvg').classList.remove('displayNone')
                    } else {
                        customCheckboxWrap[i].querySelector('.customCheckboxSvg').classList.add('displayNone')
                    }
                }

                customCheckboxWrap[i].querySelector('.availabilityCount').innerText = list.querySelector('.availabilityCount').innerText
                let isDisabled = list.dataset.isDisabled
                customCheckboxWrap[i].dataset.isDisabled = isDisabled
                if (isDisabled) {
                    customCheckboxWrap[i].classList.add('customCheckboxDisabled')
                } else {
                    customCheckboxWrap[i].classList.remove('customCheckboxDisabled')
                }
            })

            if (constFilterWtapper) {
                constFilterWtapper.after(...newGridElements)
            } else {
                root.querySelector('.collectionGrid').append(...newGridElements) 
            }

            collectionpagination.children[0].remove()
            collectionpagination.append(dom.querySelector('.collectionpagination').children[0])
            if(pageChange) {
                window.scrollTo({
                    top: collectionProductGrid.offsetTop - 65,                
                    behavior: 'smooth'
                });
            }
            pageChange = false
            

            if(cache.length > 20) {
                cache.shift()
            }
            cache.push({url: params ? `?${params}` : '', dom: domAsText})

            if(params && !navigationOccured) {
                updateHistory(`?${params}`)
            }


            countFiltersFromParams()
            setFilterWrapHeight()
            toggleLoadingIcons()
            navigationOccured = false

        }

        async function fetchSection() {
            toggleLoadingIcons()

            let params = ""
            
            for(filter in filtersList) {
                let val = filtersList[filter]
                if(val) {
                    params += `${val}&`
                }
            }

            if (params) {
                params = params.substring(0, params.length - 1)
            }

            const res = await fetch(`${window.location.pathname}?section_id=${sectionId}&${params}`);
            const text = await res.text();
            const dom = new DOMParser().parseFromString(text, 'text/html')
            updateGridItems(dom, params, text)
        }

        
        function countFiltersFromParams() {
            if(!filterCounterSpan) { return }
            let searchParams = window.location.search 
            let count = 0
            if(searchParams) {
                let splitParamsToCount = searchParams.split('&')
                splitParamsToCount.forEach(f => {
                    if(f.includes('filter')) {
                        count ++
                    }
                })
            }

            filterCounterSpan.innerText = count
            if (count > 0) {
                clearFiltersBtn.classList.remove('displayNone')
            } else {
                clearFiltersBtn.classList.add('displayNone')
            }
        }

        function updateHistory(newUrl) {
            history.pushState(filtersList, '', newUrl)
        }

        function debounce(func, timeout = 300) {
            let timer
            return () => {
                clearTimeout(timer)
                timer = setTimeout(()=> {func()}, timeout)
            }
        }

        (function populatePrices() {
            let searchParams = window.location.search 
            if (searchParams) {
                let splitParams = searchParams.split('&') 
                splitParams.forEach(param => {
                    if (param.includes('filter.v.price.gte')) {
                        let extractVal = param.split("=")[1]
                        priceFilterMin.value = extractVal
                        filtersList.minPrice = `filter.v.price.gte=${extractVal}`
                    } else if (param.includes('filter.v.price.lte')) {
                        let extractVal = param.split("=")[1]
                        priceFilterMax.value = extractVal
                        filtersList.maxPrice = `filter.v.price.lte=${extractVal}`
                    }
                })

            }
        })()

        function toggleLoadingIcons() {
            iconStaticWrap.forEach(el => {
                el.classList.toggle('displayNone')
            })
            iconLoadingWrap.forEach(el => {
                el.classList.toggle('displayNone')
            })
        }


        function initFilters() {
            filtersList.sortBy = `sort_by=${root.querySelector('.sortBarBtns.btnActive').dataset.sortValue}`

            customCheckboxWrap.forEach(checkbox => {
                if(checkbox.dataset.isChecked == 'true'){
                    const filterValue = checkbox.dataset.filterWithValue
                    if (filtersList.filters.length == 0) {
                        filtersList.filters += filterValue
                    } else {
                        filtersList.filters += `&${filterValue}`
                    }
                }
            })


        }
        initFilters()
    

    }

});

